import React from 'react'
import { Radio, RadioGroupProps, Space, SpaceProps, Typography } from 'antd'
import { FieldError } from 'react-hook-form'
import ErrorText from 'src/app/shared/components/common/error-text'
import './index.scss'

const CustomRadioButton: React.FC<
  Omit<RadioGroupProps, 'options'> & {
    label?: string
    required?: boolean
    error?: FieldError
    containerStyle?: React.CSSProperties
    spaceProps?: SpaceProps
    options?: Array<{ label: string; value: any }>
  }
> = (props) => {
  const { label, required, error, style, containerStyle, options, spaceProps, ...etc } = props
  return (
    <div
      className='custom-radio-button'
      style={{
        ...containerStyle,
      }}
    >
      <Typography
        style={{ textAlign: 'left', fontSize: '16px', fontWeight: 700, marginBottom: 8 }}
        className={`${required ? 'required' : ''} custom-select-label`}
      >
        {label}
      </Typography>
      <Radio.Group {...etc}>
        <Space direction={spaceProps?.direction ?? 'vertical'}>
          {options?.map((item) => (
            <Radio value={item.value}>{item.label}</Radio>
          ))}
        </Space>
      </Radio.Group>
      {error && <ErrorText>{error.message}</ErrorText>}
    </div>
  )
}

export default CustomRadioButton
